export const GET_CLIENT_EQUIPMENT_INFO = 'GET_CLIENT_EQUIPMENT_INFO';
export const SET_CLIENT_EQUIPMENT_INFO = 'SET_CLIENT_EQUIPMENT_INFO';
export const ERROR_CLIENT_EQUIPMENT_INFO = 'ERROR_CLIENT_EQUIPMENT_INFO';
